export const GET_BLOG_POSTS = "GET_BLOG_POSTS";
export const SAVE_BLOG_POSTS = "SAVE_BLOG_POSTS";
export const SEARCH_POSTS = "SEARCH_POSTS";
export const getBlogPosts = () => ({
    type: GET_BLOG_POSTS
});
export const saveBlogPosts = (posts) => ({
    type: SAVE_BLOG_POSTS,
    posts
});
export const searchPosts = (postsValue) => ({
    type: SEARCH_POSTS,
    postsValue
});